import { FlexBox } from "components/Common/FlexBox"
import { Link } from "react-router-dom"
import { BackButton } from "components/Common/BackButton"
import ChevronLeft from "components/Icons/ChevronLeft"
import { useHomePathWithSelectedDate } from "features/meal/hooks"
import PageTitleMealTypeSelection from "components/mealTypeSelection/PageTitleMealTypeSelection"

const Header = () => {
  const homePath = useHomePathWithSelectedDate()

  return (
    <FlexBox
      style={{ height: 44, padding: "9px 18px" }}
      $justify="space-between"
      $alignItems="center"
    >
      <Link to={homePath}>
        <BackButton>
          <ChevronLeft />
        </BackButton>
      </Link>

      <PageTitleMealTypeSelection />

      <BackButton></BackButton>
    </FlexBox>
  )
}

export default Header
